export default __webpack_public_path__ + "static/media/25.4fcd7a3a.png";